export const contactsData = {
    email: 'nohemivelazco3@gmail.com',
    phone: '+526863405845',
    address: 'Mexicali, Baja California - 21378 ',
    sheetAPI: 'https://sheetdb.io/api/v1/1spnrkrhu3cad'
}